// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Recent_activitiesSection__hFkZ\\+ {
  background: #2a2a2a;
  padding: 24px;
  margin-top: 16px;
}

.Recent_activitiesSection__hFkZ\\+ {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  text-align: left;
}

.Recent_activityList__9x49k {
  min-height: 100px;
}

.Recent_noActivity__iPqm6 {
  color: #666;
  text-align: center;
  padding: 20px 0;
} `, "",{"version":3,"sources":["webpack://./src/pages/dappPages/DashboardPage/Recent/Recent.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".activitiesSection {\n  background: #2a2a2a;\n  padding: 24px;\n  margin-top: 16px;\n}\n\n.activitiesSection {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  text-align: left;\n}\n\n.activityList {\n  min-height: 100px;\n}\n\n.noActivity {\n  color: #666;\n  text-align: center;\n  padding: 20px 0;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activitiesSection": `Recent_activitiesSection__hFkZ+`,
	"activityList": `Recent_activityList__9x49k`,
	"noActivity": `Recent_noActivity__iPqm6`
};
export default ___CSS_LOADER_EXPORT___;
